export default "__VITE_ASSET__BAzQ_cxa__"